export enum APP_MODULES {
    FAQ = 'faq',
    ADMINISTRATION = 'administration',
    CONTRACTS = 'contracts',
}
